<template lang="pug">
div
    Row()
        Button(size="small" type="primary" icon="md-add"  @click="addRule") {{ $i18n.t("wafrules.addRule") }}
    template(v-for="(headerItem,headerIndex) in value")
        Row(justify="end" v-if="value.length>1")
            Button(size="small" type="default" shape="circle" icon="md-close"  @click="delRule(headerIndex)")
        Input(
            :value="headerItem"
            @on-change="updateParent(headerIndex,$event)"
            :placeholder="placeholder"
            :autosize="autosize"
            :type="fieldType"
            :disabled="disabled"
        )
        Row(v-if="formItem.quickAddProps" style="margin-top: 4px; margin-bottom: 4px;")
            Button(size="small" type="default" icon="md-add"  @click="changeShowQuickAddProps(headerIndex)") {{ $i18n.t("rcmtable.quickAdd") }}
        Row(v-if="showQuickAddProps[headerIndex]" v-for="(quickAddProp, quickAddPropIndex) in formItem.quickAddProps" :key="`${headerIndex}-${quickAddPropIndex}`" :gutter="8")
            Col(:sm="24" :md="6")
                Row(align="middle")
                    Col
                        p {{quickAddProp.title}}
                    Col
                        Poptip(word-wrap width="300" :content="quickAddProp.description" placement="right")
                            Icon(type="ios-information-circle-outline" style="padding: 2px")
            Col(:sm="24" :md="18")
                Button(size="small" v-for="(item, index) in quickAddProp.templateData" :key="`${headerIndex}-${index}`" @click="quickAdd(headerIndex,item)") {{ item.label }}
</template>
<script>
export default {
    props: ["formItem", "formData", "value"],
    data() {
        return {
            placeholder: this.formItem.placeholder || "",
            autosize: this.formItem.autosize || false,
            fieldType: this.formItem.fieldType || "text",
            showQuickAddProps: [...this.value].map((item) => false),
        };
    },
    methods: {
        updateParent(index, event) {
            let newVal = [...this.value];
            newVal[index] = event.target.value;
            this.$emit("input", newVal);
            if (typeof this.formItem.watchField === "function") {
                this.formItem.watchField(newVal, this.formData);
            }
        },
        quickAdd(index, item) {
            this.updateParent(index, {
                target: { value: this.value[index] ? `${this.value[index]}\n${item.value}` : item.value },
            });
        },
        addRule() {
            let newVal = [...this.value];
            const defaultValue = 5;
            const groupMaxRulesInWafHeadersSet = this.$store.state.platformPlan.multiTenancyConfigs.maxRulesInWafHeadersSet &&
                this.$store.state.platformPlan.multiTenancyConfigs.maxRulesInWafHeadersSet.find(
                    (group) => group.groupName == this.formData.groupName
                );
            const maxRulesInWafHeadersSet = groupMaxRulesInWafHeadersSet ? groupMaxRulesInWafHeadersSet.groupMaxRulesInWafHeadersSet : defaultValue;
            if (newVal.length >= maxRulesInWafHeadersSet) {
                this.$Message.warning(this.$i18n.t("wafrules.addRuleLimitWarning"));
                return;
            }
            newVal.push("");
            this.$emit("input", newVal);
            if (typeof this.formItem.watchField === "function") {
                this.formItem.watchField(newVal, this.formData);
            }
            this.showQuickAddProps.push(false);
        },
        delRule(index) {
            let newVal = [...this.value];
            newVal.splice(index, 1);
            this.$emit("input", newVal);
            this.showQuickAddProps.splice(index, 1);
        },
        changeShowQuickAddProps(index) {
            this.$set(this.showQuickAddProps, index, !this.showQuickAddProps[index]);
        },
    },
    computed: {
        disabled() {
            return typeof this.formItem.disabled == "function" ? this.formItem.disabled() : this.formItem.disabled;
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/rcmTableFormItems/WafHeaderListInput.vue